import { Button, ButtonComponentProps, Delayed, DialogTrigger, Icon, Spinner, useDialogState } from '@finviz/website'
import classnames from 'classnames'
import * as React from 'react'

import { publishModalAsyncModule } from '../../modals/publish/async-modules'
import ChartLayout from '../../models/chart_layout'
import { useAsyncModule } from '../../utils/async-modules-utils'

interface PublishProps extends Pick<ButtonComponentProps, 'theme' | 'size' | 'rounding'> {
  model: ChartLayout
}

export function Publish({ model, ...props }: React.PropsWithChildren<PublishProps>) {
  const dialog = useDialogState()
  const [publishModalModule, { isLoading }] = useAsyncModule({
    ...publishModalAsyncModule,
    shouldLoadModule: dialog.visible,
    errorSeverity: 'medium',
    onError: () => dialog.hide(),
  })
  const PublishDialog = publishModalModule?.default
  const buttonProps = isLoading
    ? ({
        leftContent: (
          <Delayed
            delayComponent={
              <Icon name="share" className={classnames({ 'text-white': props.theme === 'headerItem' })} />
            }
          >
            <Spinner width={16} />
          </Delayed>
        ),
      } as ButtonComponentProps)
    : ({
        as: DialogTrigger,
        state: dialog,
        leftContent: 'share',
      } as ButtonComponentProps<typeof DialogTrigger>)

  return (
    <>
      <Button
        {...buttonProps}
        {...props}
        as={buttonProps.as}
        contentClass="hidden lg:flex"
        active={dialog.visible}
        appearance={props.children ? undefined : 'square'}
        title={props.children ? undefined : 'Share chart'}
      />
      {PublishDialog && <PublishDialog state={dialog} layoutModel={model} />}
    </>
  )
}
